<template>
  <b-overlay :show="loading" class="animated">
    <modal-trash-basket
      v-if="show_modal"
      :entity_type="entity_type"
      :trash="trash"
      @onUpdate="onUpdate"
    />
    <v-server-table
      :columns="table_config.columns"
      :options="table_config.options"
      :theme="theme"
      :ref="ref"
      id="prep-process-server-table"
      class="w-100"
    >
      <div v-if="!sample_type_id" slot="beforeTable" class="pt-3">
        <select-filter
          variant="info"
          :icon="sample_type.icon"
          placeholder="All Sample Types"
          :collection="sample_type.filters"
          value-key="id"
          text-key="name"
          filter-field="prep_process_sample_types.sample_type_id"
          filter-operator="eq"
          @onSelect="setCustomFilter('sample_type', $event)"
        />
      </div>
      <span slot="name" slot-scope="{ row }">
        <a :href="`#/prep-processes/${row.id}`" class="btn-link">{{
          row.name
        }}</a>
      </span>
      <span slot="sample_types" slot-scope="{ row }">
        {{ formatSampleTypes(row) }}
      </span>
      <span slot="actions" slot-scope="{ row }">
        <a
          v-show="checkPermission('edit prep process')"
          class="btn btn-warning px-1 py-0 text-white mr-1"
          :href="`#/prep-processes/${row.id}/edit`"
        >
          <i class="fa fa-pencil" />
        </a>
        <template v-if="checkPermission('delete analysis')">
          <a
            v-if="isDeleted(row.id)"
            class="btn btn-success px-1 py-0 text-white mr-1"
            @click="restoreFromTrash(row.id)"
          >
            <i class="fa fa-refresh" />
          </a>
          <a
            v-else
            class="btn btn-danger px-1 py-0 text-white mr-1"
            @click="putToTrash(row)"
          >
            <i class="fa fa-trash" />
          </a>
        </template>
      </span>
    </v-server-table>
  </b-overlay>
</template>

<script>
import Vue from "vue";
import PrepProcessCollection from "@/collections/lab/PrepProcessCollection";
import BaseServerTable from "@/components/shared/BaseServerTable";
import ModalTrashBasket from "@/components/shared/ModalTrashBasket";
import SelectFilter from "@/components/shared/SelectFilter";
import SampleTypeModel from "@/models/lab/SampleTypeModel";
import { mapActions, mapGetters } from "vuex";
import { ServerTable } from "vue-tables-2";
import { AccessControlCheck } from "@/auth/AccessControlCheck";
import { getCollection } from "@/shared/fetch-utils";

Vue.use(ServerTable);

export default {
  name: "PrepProcessServerTable",
  extends: BaseServerTable,
  components: {
    ModalTrashBasket,
    ServerTable,
    SelectFilter,
  },
  props: {
    collection: {
      type: Object,
      default: () => new PrepProcessCollection(),
    },
    sample_types: {
      type: Object,
      default: () => null,
    },
    show_columns: {
      type: Array,
      default: () => ["name", "sample_types", "description", "actions"],
    },
    filterable: {
      type: Array,
      default: () => ["searchable"],
    },
    sortable: {
      type: Array,
      default: () => ["name"],
    },
  },
  data() {
    const actions_access =
      this.checkPermission("edit prep process") ||
      this.checkPermission("delete prep process");

    return {
      entity_type: "prepProcess",
      sample_type_collection: null,
      sample_type_id: this.$route.params.sample_type_id || null,
      table_config: Object.assign(this.getDefaultTableConfig(actions_access), {
        options: {
          headings: {
            name: "Name",
            sample_types: "Sample Types",
            description: "Description",
            actions: "Actions",
          },
          filterable: this.filterable,
          sortable: this.sortable,
        },
      }),
    };
  },
  computed: {
    ...mapGetters({
      trash: "prepProcessTrash",
    }),
    sample_type() {
      return {
        icon: `fa-${SampleTypeModel.iconStatic()}`,
        filters: this.sample_types || this.sample_type_collection,
      };
    },
    show_modal() {
      return (
        this.checkPermission("delete prep process") &&
        this.show_columns.includes("actions")
      );
    },
  },
  methods: {
    ...mapActions(["PUT_TO_TRASH", "RESTORE_FROM_TRASH"]),
    putToTrash(value) {
      this.PUT_TO_TRASH({ value, name: this.entity_type });
    },
    restoreFromTrash(id) {
      this.RESTORE_FROM_TRASH({ id, name: this.entity_type });
    },
    isDeleted(id) {
      return this.trash.find((item) => item.id === id);
    },
    onUpdate() {
      this.$refs[this.ref].refresh();
    },
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
    formatSampleTypes(prep_process) {
      return prep_process.sample_types.length
        ? prep_process.sample_types
            .map(({ name }) => name)
            .sort()
            .join(", ")
        : null;
    },
    prepareCollectionFilter(filter) {
      this.sample_type_id &&
        filter.filterEquals("sample_types.id", this.sample_type_id);
        
      return filter;
    },
    async init() {
      !this.sample_types &&
        !this.sample_type_id &&
        (this.sample_type_collection = await getCollection({
          collection_type: "sample_type",
          limit: "all",
          message: this.$bvToast,
        }));
    },
  },
  created() {
    this.init();
  },
};
</script>
